import { CSSProperties } from "react";
import { colors } from "shared/theme/color";
import { textPx } from "shared/constants/zoom";

// The one style for an uppercase label that names a group of content on a
// page: the hub pages (Pengaturan, Laporan), the settings pages' option
// groups, the Home dashboard's sections and the reward settings cards. Dark
// grey on purpose: ink3 is 2.8:1 on white, under the 4.5:1 text minimum.
// Modal eyebrows, create-panel steps and table headers are other roles with
// their own styles.
export const sectionLabelStyle: CSSProperties = {
  fontSize: textPx(12),
  fontWeight: 600,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: colors.ink2,
};

// Uppercase micro-label naming a group of hub rows (the Laporan index and the
// Pengaturan launcher). It names the group instead of just separating it,
// which a divider line would.
//
// role/aria-level rather than a real <h2>, because index.css applies the
// display font to h2 and that would drift these labels visually. The role
// gives the grids a document outline at zero pixel cost.
const NavSectionLabel = ({ children }: { children: string }) => (
  <span
    role="heading"
    aria-level={2}
    style={{ ...sectionLabelStyle, display: "block", marginTop: 8, marginBottom: 5 }}
  >
    {children}
  </span>
);

export default NavSectionLabel;
